module.exports = __webpack_public_path__ + "static/media/achievement-bronze-runner.457f1214.svg";